export enum TUploadSize {
  SMALL = 'SMALL',
  BIG = 'BIG',
}
